import { render, staticRenderFns } from "./SafetyManageDoc.vue?vue&type=template&id=54a2e11e&scoped=true&"
import script from "./SafetyManageDoc.vue?vue&type=script&lang=js&"
export * from "./SafetyManageDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a2e11e",
  null
  
)

export default component.exports